import { Component } from '@angular/core';
import { PaginatorModule } from "primeng/paginator";
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { ProductsService } from "../service/products.service";
import { HttpClient } from "@angular/common/http";
import { NotificationService } from "../service/notification.service";

@Component({
    selector: 'app-contact',
    standalone: true,
    imports: [
        PaginatorModule,
        ReactiveFormsModule
    ],
    templateUrl: './contact.component.html',
    styleUrl: './contact.component.scss'
})
export class ContactComponent {
    contactForm: FormGroup;
    emailPattern: RegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

    constructor(
        private httpClient: HttpClient,
        private productsService: ProductsService,
        private ns: NotificationService,
        private fb: FormBuilder) {
        this.contactForm = this.fb.group({
            name: ['', Validators.required],
            email: <any>['', Validators.compose([Validators.required, Validators.pattern(this.emailPattern)])],
            city: ['', Validators.required],
            productName: ['', Validators.required],
            contactNumber: <any>['', [Validators.required, Validators.maxLength(10), Validators.minLength(10)]],
            message: ['', Validators.required],
        });
    }

    async onSubmit() {
        if (this.contactForm.valid) {
            await this.sendEmail();
            this.contactForm.reset();
            this.ns.showSuccess("Mail Sent Successfully.");
        } else alert("Please enter valid data.");
    }

    async sendEmail() {
        let contact = this.contactForm.value;
        await this.productsService.sendContactMail(contact);
    }
}
